
import FullPicture from "@/components/FullPicture.vue";
import ArticlesLine from "@/components/ArticlesLine.vue";
export default {
  components: { FullPicture, ArticlesLine },
  setup() {
    return {};
  }
};
